import logoSrc from '@/assets/logo.svg'
import { Coins } from 'lucide-react'

interface OnboardingHeaderProps {
  creditsAvailable: number
}

export function OnboardingHeader({ creditsAvailable }: OnboardingHeaderProps) {
  return (
    <header className="relative overflow-hidden rounded-2xl border border-white/70 bg-white/85 p-5 shadow-[0_10px_35px_rgba(0,0,0,0.08)] backdrop-blur-sm sm:p-6">
      <div className="absolute inset-x-0 top-0 h-1.5 bg-gradient-to-r from-spectrum-teal via-spectrum-blue to-spectrum-cyan" />
      <div className="relative flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-2">
          <img src={logoSrc} alt="LinkToCreative" className="h-16 w-auto object-contain sm:h-[4.75rem]" />
          <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-spectrum-blue">
              Guided Setup
            </p>
            <h1 className="text-xl font-bold text-gray-900 sm:text-2xl">Onboarding</h1>
            <p className="text-sm text-gray-600">Set up your first AI-powered creative workflow in 4 steps.</p>
          </div>
        </div>

        <div className="inline-flex items-center gap-2 self-start rounded-full border border-gray-200 bg-white px-3 py-1.5 text-sm text-gray-700 shadow-sm sm:self-center">
          <Coins className="h-4 w-4 text-amber-500" />
          <span className="font-medium">Credits</span>
          <span className="rounded-full bg-gray-100 px-2 py-0.5 text-xs font-semibold text-gray-900">
            {creditsAvailable}
          </span>
        </div>
      </div>
    </header>
  )
}
